/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { ixmUserauthV1UserSessionCommandServiceRefreshSession } from '@interxfi/api-client/generated/client-functions/ixm-userauth-v1-user-session-command-service-refresh-session';
import type { IxmUserauthV1UserSessionCommandServiceRefreshSessionRequest, IxmUserauthV1UserSessionCommandServiceRefreshSessionResponse } from '@interxfi/types';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { ixmUserauthV1UserSessionStateEntity } from '../entities/ixm-userauth-v1-user-session-state';

/**
 * @generated by NormalizedQueryPlugin (post /portal/userauth/v1/session/c/:sessionId/refresh) */

export function buildIxmUserauthV1UserSessionCommandServiceRefreshSessionKey() { return ['/ixm.userauth.v1.UserSessionCommandService/RefreshSession'] as const; }

export function useIxmUserauthV1UserSessionCommandServiceRefreshSession(options?: Partial<UseMutationOptions<IxmUserauthV1UserSessionCommandServiceRefreshSessionResponse | undefined, Error, IxmUserauthV1UserSessionCommandServiceRefreshSessionRequest, unknown>>) {
    return useMutation({
        mutationKey: buildIxmUserauthV1UserSessionCommandServiceRefreshSessionKey(),
        mutationFn: async (request: IxmUserauthV1UserSessionCommandServiceRefreshSessionRequest) => ixmUserauthV1UserSessionCommandServiceRefreshSession('', request),
        ...options
    });
}
